<template>
  <v-container>
    <v-row justify="space-around">
      <v-col cols="12">
        <!-----------------------------STEPPER START ------------------------------------------------->
        <v-stepper
            v-model="stepper.currentStep"
            :alt-labels="stepper.altLabels"
            :vertical="stepper.vertical"
        >
          <template>
            <!-----------------------------STEPPER HEADER------------------------------------------------->
            <v-stepper-header>
              <template>
                <v-stepper-step :step="1">
                  {{ $t("ADMISSION_DATA.STEP1.NAME") }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :step="2"
                >{{ $t("ADMISSION_DATA.STEP2.NAME") }}
                </v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :step="3"
                >{{ $t("ADMISSION_DATA.STEP3.NAME") }}
                </v-stepper-step>
                <template
                    v-if="!data.appStatus || ['0','-2', '7'].includes(data.appStatus)
                    || (data.appStatus==='4' && data.checkPayment===0)
                      || data.feesRules.value2 ==='receipt' "
                >
                  <v-divider></v-divider>
                  <v-stepper-step :step="4"
                  >{{ $t("ADMISSION_DATA.STEP4.NAME") }}
                  </v-stepper-step>
                </template>
              </template>
            </v-stepper-header>
            <!-----------------------------STEPPER END HEADER------------------------------------------------->
            <!-----------------------------STEPPER CONTENT------------------------------------------------->
            <v-stepper-items>
              <template v-if="data.appStatus != '7'">
                <v-form ref="stepForm1">
                  <v-stepper-content ref="step1" step="1">
                    <v-row>
                      <v-col cols="12">
                        <v-card outlined>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1"
                              >{{ $t("ADMISSION_DATA.STEP1.PERSONAL_DATA") }}
                              </v-list-item-title>
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                      ref="arName"
                                      v-model="data.arName"
                                      :label="
                                      $t('ADMISSION_DATA.STEP1.AR_FULLNAME')
                                    "
                                      :rules="arNameRules"
                                      clearable
                                      counter="100"
                                      maxlength="100"
                                      disabled
                                      outlined
                                      @keydown.space="preventLeadingSpace"
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="6">
                                  <v-text-field
                                      ref="enName"
                                      v-model="data.enName"
                                      :label="
                                      this.$t(
                                        'ADMISSION_DATA.STEP1.EN_FULLNAME'
                                      )
                                    "
                                      :rules="enNameRules"
                                      clearable
                                      counter="100"
                                      maxlength="100"
                                      disabled
                                      outlined
                                      @keydown.space="preventLeadingSpace"
                                  ></v-text-field>
                                </v-col>

                                <!-----------------------------PERSONAL IMAGE------------------------------------------------->
                                <v-col cols="12">
                                  <v-template
                                      v-if="
                                      personalImgDelete ||
                                        !data.personalImageURL
                                    "
                                  >
                                    <v-file-input
                                        ref="personalImage"
                                        v-model="personalImage"
                                        :label="$t('ADMISSION_DATA.STEP1.IMAGE')"
                                        :placeholder="
                                        $t('ADMISSION_DATA.STEP1.IMAGE')
                                      "
                                        :rules="imageRule"
                                        :show-size="1000"
                                        accept="image/*"
                                        color="primary"
                                        outlined
                                        prepend-icon="mdi-paperclip"
                                    >
                                      <template
                                          v-slot:selection="{ index, text }"
                                      >
                                        <v-chip
                                            v-if="index < 2"
                                            color="primary"
                                            dark
                                            label
                                            small
                                        >
                                          {{ text }}
                                        </v-chip>
                                      </template>
                                    </v-file-input>
                                  </v-template>
                                  <v-template v-else>
                                    <legend class="grey--text pb-1">
                                      {{ $t("ADMISSION_DATA.STEP1.IMAGE") }}
                                    </legend>
                                    <a
                                        ref="#"
                                        @click="previewImage('personalImg')"
                                    >personal image...</a
                                    >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                            class="ms-3"
                                            color="error"
                                            meduim
                                            @click="deleteImage('personalImg')"
                                            v-on="on"
                                        >mdi-delete
                                        </v-icon>
                                      </template>
                                      <span>{{
                                          $t("ADMISSION_DATA.UPLOAD_IMG")
                                        }}</span>
                                    </v-tooltip>
                                    <v-divider class="mt-2"></v-divider>
                                  </v-template>
                                </v-col>
                                <!-----------------------------END PERSONAL IMAGE------------------------------------------------->

                                <v-col cols="12" lg="4">
                                  <v-radio-group
                                      v-model="data.cardType"
                                      :disabled="allowDisabled"
                                      row
                                  >
                                    <template v-slot:label>
                                      <div>
                                        {{ $t("ADMISSION_DATA.STEP1.IDTYPE") }}
                                      </div>
                                    </template>
                                    <v-radio
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.NATIONALID')
                                      "
                                        :value="1"
                                    ></v-radio>
                                    <v-radio
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.PASSPORT')
                                      "
                                        :value="2"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>

                                <v-col cols="12" lg="4">
                                  <v-text-field
                                      ref="cardID"
                                      v-model="data.cardID"
                                      :counter="data.cardType === 1 ? 14 : 25"
                                      :disabled="allowDisabled"
                                      :hint="$t('ADMISSION_DATA.STEP1.IDHINT')"
                                      :label="$t('ADMISSION_DATA.STEP1.ID')"
                                      :maxlength="data.cardType === 1 ? 14 : 25"
                                      clearable
                                      outlined
                                      @keydown.space="preventLeadingSpace"
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="6" lg="4">
                                  <v-template
                                      v-if="cardDeleted || !data.cardImageURL"
                                  >
                                    <v-file-input
                                        ref="cardImage"
                                        v-model="cardImage"
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.ID_IMAGE')
                                      "
                                        :placeholder="
                                        $t('ADMISSION_DATA.STEP1.ID_IMAGE')
                                      "
                                        :rules="cardImageRule"
                                        :show-size="1000"
                                        accept="image/*"
                                        color="primary"
                                        outlined
                                        prepend-icon="mdi-paperclip"
                                    >
                                      <template
                                          v-slot:selection="{ index, text }"
                                      >
                                        <v-chip
                                            v-if="index < 2"
                                            color="primary"
                                            dark
                                            label
                                            small
                                        >
                                          {{ text }}
                                        </v-chip>
                                      </template>
                                    </v-file-input>
                                  </v-template>
                                  <v-template v-else>
                                    <legend class="grey--text pb-1">
                                      {{ $t("ADMISSION_DATA.STEP1.ID_IMAGE") }}
                                    </legend>
                                    <a ref="#" @click="previewImage('card')"
                                    >IdentityCard...</a
                                    >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                            class="ms-3"
                                            color="error"
                                            meduim
                                            @click="deleteImage('card')"
                                            v-on="on"
                                        >mdi-delete
                                        </v-icon>
                                      </template>
                                      <span>{{
                                          $t("ADMISSION_DATA.UPLOAD_IMG")
                                        }}</span>
                                    </v-tooltip>

                                    <v-divider class="mt-2"></v-divider>
                                  </v-template>
                                </v-col>

                                <v-col cols="6" lg="4">
                                  <v-radio-group
                                      v-model="data.gender"
                                      :disabled="allowDisabled"
                                      row
                                  >
                                    <template v-slot:label>
                                      <div>
                                        {{ $t("ADMISSION_DATA.STEP1.TYPE") }}
                                      </div>
                                    </template>
                                    <v-radio :value="13">
                                      <template v-slot:label>
                                        <div>
                                          {{ $t("ADMISSION_DATA.STEP1.MALE") }}
                                        </div>
                                      </template>
                                    </v-radio>
                                    <v-radio :value="14">
                                      <template v-slot:label>
                                        <div>
                                          {{
                                            $t("ADMISSION_DATA.STEP1.FEMALE")
                                          }}
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>

                                <v-col cols="6" lg="4">
                                  <v-radio-group
                                      v-model="data.religion"
                                      :disabled="allowDisabled"
                                      row
                                  >
                                    <template v-slot:label>
                                      <div>
                                        {{ $t("ADMISSION_DATA.STEP1.RELIGION") }}
                                      </div>
                                    </template>
                                    <v-radio :value="84">
                                      <template v-slot:label>
                                        <div>
                                          {{ $t("ADMISSION_DATA.STEP1.MUSLIM") }}
                                        </div>
                                      </template>
                                    </v-radio>
                                    <v-radio :value="85">
                                      <template v-slot:label>
                                        <div>
                                          {{
                                            $t("ADMISSION_DATA.STEP1.CHRISTIAN")
                                          }}
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>

                                <v-col cols="6" lg="4">
                                  <v-menu
                                      v-model="pickerMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                          v-model="data.dOB"
                                          :disabled="allowDisabled"
                                          :label="
                                          $t('ADMISSION_DATA.STEP1.BIRTHDATE')
                                        "
                                          outlined
                                          prepend-icon="event"
                                          readonly
                                          v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data.dOB"
                                        :locale="locale"
                                        @input="pickerMenu = false"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>

                                <v-col cols="12" lg="4">
                                  <v-autocomplete
                                      v-model="data.nationalityCountry"
                                      :disabled="allowDisabled"
                                      :items="
                                      serverTranslateArray(
                                        data.countriesList,
                                        'name'
                                      )
                                    "
                                      :label="
                                      $t('ADMISSION_DATA.STEP1.NATIIONALITY')
                                    "
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      @keydown.space="preventLeadingSpace"
                                  ></v-autocomplete>
                                </v-col>

                                <!--birth place  -->
                                <v-col cols="12">
                                  <v-card outlined>
                                    <v-list-item three-line>
                                      <v-list-item-content>
                                        <v-list-item-title class="headline mb-1"
                                        >{{
                                            $t(
                                                "ADMISSION_DATA.STEP1.BIRTHPLACE"
                                            )
                                          }}
                                        </v-list-item-title>
                                        <v-row>
                                          <v-col cols="12" lg="4">
                                            <v-autocomplete
                                                v-model="data.birthPlaceCountry"
                                                :items="
                                                serverTranslateArray(
                                                  data.countriesList,
                                                  'name'
                                                )
                                              "
                                                :label="
                                                $t(
                                                  'ADMISSION_DATA.STEP1.COUNTRY'
                                                )
                                              "
                                                :rules="requiredRules"
                                                chips
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                outlined
                                                @change="
                                                ChangeCountry('birthPlace')
                                              "
                                                @keydown.space="
                                                preventLeadingSpace
                                              "
                                            ></v-autocomplete>
                                          </v-col>
                                          <v-col cols="12" lg="4">
                                            <v-autocomplete
                                                v-model="data.birthPlaceState"
                                                :items="
                                                serverTranslateArray(
                                                  data.birthStatesList,
                                                  'name'
                                                )
                                              "
                                                :label="
                                                $t('ADMISSION_DATA.STEP1.STATE')
                                              "
                                                chips
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                outlined
                                                @change="
                                                ChangeState('birthPlace')
                                              "
                                                @keydown.space="
                                                preventLeadingSpace
                                              "
                                            ></v-autocomplete>
                                          </v-col>
                                          <v-col cols="12" lg="4">
                                            <v-autocomplete
                                                v-model="data.birthPlaceCity"
                                                :items="
                                                serverTranslateArray(
                                                  data.birthCitiesList,
                                                  'name'
                                                )
                                              "
                                                :label="
                                                $t('ADMISSION_DATA.STEP1.CITY')
                                              "
                                                chips
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                outlined
                                                @keydown.space="
                                                preventLeadingSpace
                                              "
                                            ></v-autocomplete>
                                          </v-col>
                                        </v-row>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-card>
                                </v-col>
                                <!-- -->
                                <v-col cols="12" lg="4">
                                  <v-template
                                      v-if="
                                      birthCertDeleted || !data.birthCertUrl
                                    "
                                  >
                                    <v-file-input
                                        ref="birthCert"
                                        v-model="birthCert"
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.BIRTH_CERT')
                                      "
                                        :placeholder="
                                        $t('ADMISSION_DATA.STEP1.BIRTH_CERT')
                                      "
                                        :rules="birthCertRule"
                                        :show-size="1000"
                                        accept="image/*"
                                        color="primary"
                                        outlined
                                        prepend-icon="mdi-paperclip"
                                    >
                                      <template
                                          v-slot:selection="{ index, text }"
                                      >
                                        <v-chip
                                            v-if="index < 2"
                                            color="primary"
                                            dark
                                            label
                                            small
                                        >
                                          {{ text }}
                                        </v-chip>
                                      </template>
                                    </v-file-input>
                                  </v-template>
                                  <v-template v-else>
                                    <legend class="grey--text pb-1">
                                      {{
                                        $t("ADMISSION_DATA.STEP1.BIRTH_CERT")
                                      }}
                                    </legend>
                                    <a
                                        ref="#"
                                        @click="previewImage('birthCert')"
                                    >BirthCertificate...</a
                                    >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                            class="ms-3"
                                            color="error"
                                            meduim
                                            @click="deleteImage('birthCert')"
                                            v-on="on"
                                        >mdi-delete
                                        </v-icon>
                                      </template>
                                      <span>{{
                                          $t("ADMISSION_DATA.UPLOAD_IMG")
                                        }}</span>
                                    </v-tooltip>
                                    <v-divider class="mt-2"></v-divider>
                                  </v-template>
                                </v-col>
                                <v-col cols="12" lg="4">
                                  <v-template
                                      v-if="
                                      guardianCardDeleted ||
                                        !data.guardianCardUrl
                                    "
                                  >
                                    <v-file-input
                                        ref="guardianCard"
                                        v-model="guardianCard"
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.GUARDIAN_CARD')
                                      "
                                        :placeholder="
                                        $t('ADMISSION_DATA.STEP1.GUARDIAN_CARD')
                                      "
                                        :rules="guardianCardRule"
                                        :show-size="1000"
                                        accept="image/*"
                                        color="primary"
                                        outlined
                                        prepend-icon="mdi-paperclip"
                                    >
                                      <template
                                          v-slot:selection="{ index, text }"
                                      >
                                        <v-chip
                                            v-if="index < 2"
                                            color="primary"
                                            dark
                                            label
                                            small
                                        >
                                          {{ text }}
                                        </v-chip>
                                      </template>
                                    </v-file-input>
                                  </v-template>
                                  <v-template v-else>
                                    <legend class="grey--text pb-1">
                                      {{
                                        $t("ADMISSION_DATA.STEP1.GUARDIAN_CARD")
                                      }}
                                    </legend>
                                    <a
                                        ref="#"
                                        @click="previewImage('guardianCard')"
                                    >GuardianCard...</a
                                    >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                            class="ms-3"
                                            color="error"
                                            meduim
                                            @click="deleteImage('guardianCard')"
                                            v-on="on"
                                        >mdi-delete
                                        </v-icon>
                                      </template>
                                      <span>{{
                                          $t("ADMISSION_DATA.UPLOAD_IMG")
                                        }}</span>
                                    </v-tooltip>
                                    <v-divider class="mt-2"></v-divider>
                                  </v-template>
                                </v-col>
                                <v-col
                                    v-if="data.gender == 13"
                                    cols="12"
                                    lg="4"
                                >
                                  <v-template
                                      v-if="
                                      militaryFormDeleted ||
                                        !data.militaryFormUrl
                                    "
                                  >
                                    <v-file-input
                                        ref="militaryForm"
                                        v-model="militaryForm"
                                        :label="
                                        $t('ADMISSION_DATA.STEP1.MILITARY_FORM')
                                      "
                                        :placeholder="
                                        $t('ADMISSION_DATA.STEP1.MILITARY_FORM')
                                      "
                                        :rules="militaryFormRule"
                                        :show-size="1000"
                                        accept="image/*"
                                        color="primary"
                                        outlined
                                        prepend-icon="mdi-paperclip"
                                    >
                                      <template
                                          v-slot:selection="{ index, text }"
                                      >
                                        <v-chip
                                            v-if="index < 2"
                                            color="primary"
                                            dark
                                            label
                                            small
                                        >
                                          {{ text }}
                                        </v-chip>
                                      </template>
                                    </v-file-input>
                                  </v-template>
                                  <v-template v-else>
                                    <legend class="grey--text pb-1">
                                      {{
                                        $t("ADMISSION_DATA.STEP1.MILITARY_FORM")
                                      }}
                                    </legend>
                                    <a
                                        ref="#"
                                        @click="previewImage('militaryForm')"
                                    >MilitaryForm...</a
                                    >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                            class="ms-3"
                                            color="error"
                                            meduim
                                            @click="deleteImage('militaryForm')"
                                            v-on="on"
                                        >mdi-delete
                                        </v-icon>
                                      </template>
                                      <span>{{
                                          $t("ADMISSION_DATA.UPLOAD_IMG")
                                        }}</span>
                                    </v-tooltip>
                                    <v-divider class="mt-2"></v-divider>
                                  </v-template>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>

                      <v-col cols="12">
                        <v-card outlined>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1"
                              >{{ $t("ADMISSION_DATA.STEP1.CONTACTS") }}
                              </v-list-item-title>
                              <v-row>
                                <v-col cols="12" lg="4">
                                  <vue-tel-input
                                      ref="mobile"
                                      v-model="data.mobile"
                                      :class="
                                      bindProps.inputClasses === 'error--text'
                                        ? 'error--border'
                                        : ''
                                    "
                                      :preferredCountries="['eg']"
                                      :rules="requiredRules"
                                      class="mb-2"
                                      clearable
                                      outlined
                                      v-bind="bindProps"
                                      @blur="validateMobileInBlur"
                                      @validate="IsValid"
                                      @keydown.space="preventLeadingSpace"
                                  >
                                  </vue-tel-input>
                                  <div
                                      v-if="
                                      bindProps.inputClasses === 'error--text'
                                    "
                                      class="v-text-field__details ms-2"
                                  >
                                    <div
                                        class="v-messages theme--light error--text"
                                        role="alert"
                                    >
                                      <div class="v-messages__wrapper">
                                        <div class="v-messages__message">
                                          {{
                                            !data.mobile
                                                ? $t("REQUIRED_FIELD")
                                                : $t("MOBILE_VALIDATION")
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-col>

                                <v-col cols="12" lg="4">
                                  <v-text-field
                                      ref="telephone"
                                      v-model="data.telephone"
                                      :label="
                                      $t('ADMISSION_DATA.STEP1.TELEPHONE')
                                    "
                                      :rules="phoneRules"
                                      clearable
                                      counter="20"
                                      maxlength="20"
                                      outlined
                                      @keydown.space="preventLeadingSpace"
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" lg="4">
                                  <v-text-field
                                      ref="email"
                                      v-model="data.email"
                                      :disabled="allowDisabled"
                                      :label="$t('ADMISSION_DATA.STEP1.EMAIL')"
                                      clearable
                                      counter="100"
                                      maxlength="100"
                                      outlined
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>

                      <v-col cols="12">
                        <v-card outlined>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1"
                              >{{ $t("ADMISSION_DATA.STEP1.ADDRESS") }}
                              </v-list-item-title>
                              <v-row>
                                <v-col cols="12" lg="4">
                                  <v-autocomplete
                                      v-model="data.addressCountry"
                                      :items="
                                      serverTranslateArray(
                                        data.countriesList,
                                        'name'
                                      )
                                    "
                                      :label="$t('ADMISSION_DATA.STEP1.COUNTRY')"
                                      :rules="requiredRules"
                                      chips
                                      dense
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      @change="ChangeCountry('address')"
                                      @keydown.space="preventLeadingSpace"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="4">
                                  <v-autocomplete
                                      v-model="data.addressState"
                                      :items="
                                      serverTranslateArray(
                                        data.addressStatesList,
                                        'name'
                                      )
                                    "
                                      :label="$t('ADMISSION_DATA.STEP1.STATE')"
                                      chips
                                      dense
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      @change="ChangeState('address')"

                                      @keydown.space="preventLeadingSpace"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="4">
                                  <v-autocomplete
                                      v-model="data.addressCity"
                                      :items="
                                      serverTranslateArray(
                                        data.addressCitiesList,
                                        'name'
                                      )
                                    "
                                      :label="$t('ADMISSION_DATA.STEP1.CITY')"
                                      chips
                                      dense
                                      item-text="name"
                                      item-value="id"
                                      outlined

                                      @keydown.space="preventLeadingSpace"
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>

                      <v-row class="d-flex  mx-7 justify-end ">
                        <v-btn class="ma-2" color="error" @click="cancel()">
                          {{ $t("CANCEL") }}
                        </v-btn>
                        <v-btn class="ma-2" color="primary" @click="nextStep(1)"
                        >{{ $t("ADMISSION_DATA.NEXT") }}
                        </v-btn>
                      </v-row>
                    </v-row>
                  </v-stepper-content>
                </v-form>
                <!-----------------------------------End Step1------------------------------------------->
                <!-----------------------------------Step2------------------------------------------->
                <v-form ref="stepForm2">
                  <v-stepper-content step="2">
                    <v-row>
                      <v-col cols="12" lg="4">
                        <v-autocomplete
                            v-model="data.certificateType"
                            :disabled="data.pullFromGsApi===true"
                            :items="data.certificateTypes"
                            :label="$t('ADMISSION_DATA.STEP2.CERTIFICATION')"
                            :rules="requiredRules"
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" lg="4">
                        <v-autocomplete
                            v-model="data.divisionType"
                            :disabled="data.pullFromGsApi===true"
                            :items="divisionTypes"
                            :label="$t('ADMISSION_DATA.STEP2.MAJOR')"
                            :rules="(divisionTypes.length>0?requiredRules:[])"
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" lg="4">
                        <!--                        <v-autocomplete-->
                        <!--                            v-model="data.preQualYear"-->
                        <!--                            :disabled="data.pullFromGsApi===true"-->
                        <!--                            :items="filteredPreQualYears"-->
                        <!--                            :label="$t('ADMISSION_DATA.STEP2.YEAR')"-->
                        <!--                            :rules="requiredRules"-->
                        <!--                            item-text="name"-->
                        <!--                            item-value="hrId"-->
                        <!--                            outlined-->
                        <!--                        >-->
                        <!--                          <template v-slot:selection="data">-->
                        <!--                            <v-chip v-bind="data.attrs">-->
                        <!--                              {{ serverTranslate(data.item.name) }}-->
                        <!--                            </v-chip>-->
                        <!--                          </template>-->
                        <!--                          <template v-slot:item="data">-->
                        <!--                            <template v-if="typeof data.item === 'object'">-->
                        <!--                              <v-list-item-content>-->
                        <!--                                <v-list-item-title-->
                        <!--                                    v-html="serverTranslate(data.item.name)"-->
                        <!--                                ></v-list-item-title>-->
                        <!--                              </v-list-item-content>-->
                        <!--                            </template>-->
                        <!--                          </template>-->
                        <!--                        </v-autocomplete>-->

                        <!--  :disabled="data.pullFromGsApi === true"  -->

                        <v-autocomplete
                            v-model="selectedPreQualYear"
                            :disabled="data.pullFromGsApi===true"
                            :items="filteredPreQualYears"
                            :label="$t('ADMISSION_DATA.STEP2.YEAR')"
                            :rules="requiredRules"
                            item-text="name"
                            item-value="hrId"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>

                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title
                                  v-html="serverTranslate(data.item.name)"
                              />
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>


                      </v-col>

                      <v-col v-if="hasSubCertificateType" cols="12" lg="4">
                        <v-autocomplete
                            v-model="data.equationCertificateType"
                            :disabled="data.pullFromGsApi===true"
                            :items="data.equationCertificateTypes"
                            :label="
                            $t('ADMISSION_DATA.STEP2.EQUIVALENT_CERT_TYPE')
                          "
                            :rules="requiredRules"
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                :input-value="data.selected"
                                v-bind="data.attrs"
                                @click="data.select"
                            >
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="hasSubCertificate" cols="12" lg="4">
                        <!--@change="hasAnthorCertificate = $event == 32"-->
                        <v-autocomplete
                            v-model="data.foreignCertificate"
                            :disabled="data.pullFromGsApi===true"
                            :items="
                            data.equationCertificateType === 61
                              ? data.egyptianCertificates
                              : data.foreignCertificates
                          "
                            :label="$t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME')"
                            :rules="requiredRules"
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                :input-value="data.selected"
                                v-bind="data.attrs"
                                @click="data.select"
                            >
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="hasAnthorCertificate" cols="12" lg="4">
                        <v-text-field
                            ref="arName"
                            v-model="data.otherCertificateText"
                            :disabled="data.pullFromGsApi===true"
                            :label="
                            this.$t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME')
                          "
                            :rules="otherCertificateTextRules"
                            clearable
                            counter="75"
                            maxlength="75"
                            outlined
                            @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4">
                        <!--CERT_FROM_COUNTRY-->
                        <v-autocomplete
                            v-model="data.preQualCountry"
                            :disabled="
                              hasSubCertificateType === false ||
                              data.equationCertificateType === 61 ||
                              data.pullFromGsApi===true
                          "
                            :items="data.countriesList"
                            :label="$t('ADMISSION_DATA.STEP2.CERT_FROM_COUNTRY')"
                            :rules="
                            data.equationCertificateType === 61
                              ? ''
                              : requiredRules
                          "
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" lg="4">
                        <v-text-field
                            ref="totalDegree"
                            v-model="data.total"
                            :disabled="data.pullFromGsApi===true"
                            :label="$t('UserData.CERTIFICATE_RESULT')"
                            :rules="totalDegreeRules"
                            clearable
                            outlined
                            type="number"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" lg="4">
                        <v-text-field
                            ref="totalPercentage"
                            v-model="data.percentage"
                            :label="$t('UserData.CERTIFICATE_PERC')"
                            :rules="globalPercRule"
                            clearable
                            outlined
                            type="double"
                        ></v-text-field>
                      </v-col>

                      <!-- pdf/images prequal file -->
                      <v-col cols="12" lg="4">
                        <v-template
                            v-if="certifcateFileDelete || !data.preQualFileURL"
                        >
                          <v-file-input
                              ref="certificatesFile"
                              v-model="certificatesFile"
                              :label="$t('ADMISSION_DATA.STEP2.CERTIFICATE_FILE')"
                              :placeholder="
                              $t('ADMISSION_DATA.STEP2.CERTIFICATE_FILE')
                            "
                              :rules="certificatesFileRule"
                              :show-size="1000"
                              accept="*/*"
                              color="primary"
                              outlined
                              prepend-icon="mdi-paperclip"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                  v-if="index < 2"
                                  color="primary"
                                  dark
                                  label
                                  small
                              >
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-template>
                        <v-template v-else>
                          <legend class="grey--text pb-1">
                            {{ $t("ADMISSION_DATA.STEP2.CERTIFICATE_FILE") }}
                          </legend>
                          <!--    @click="previewImage('certificateFile')"  -->
                          <a ref="#">certificates file...</a>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                  class="ms-3"
                                  color="error"
                                  meduim
                                  @click="deleteImage('certificateFile')"
                                  v-on="on"
                              >mdi-delete
                              </v-icon>
                            </template>
                            <span>{{ $t("ADMISSION_DATA.UPLOAD_IMG") }}</span>
                          </v-tooltip>
                          <v-divider class="mt-2"></v-divider>
                        </v-template>
                      </v-col>


                      <!-- consent file تحميل ورفع الاقرار  -->
                      <v-col v-if="data.consentFileDownloadURL" cols="6" lg="4">
                        <template>
                          <v-btn :title="$t('DOWNLOAD_CONSENT_FILE')" icon @click="downloadFile">
                            <v-icon color="#00afb9" small>mdi-download</v-icon>
                          </v-btn>
                          <span>{{ $t("DOWNLOAD_CONSENT_FILE") }}</span>
                          <br>
                          <span class="red--text">{{ $t("DOWNLOAD_CONSENT_NOTES") }}</span>
                        </template>
                      </v-col>
                      <v-col v-if="data.consentFileDownloadURL" cols="6" lg="4">
                        <v-template v-if=" consentFileDelete|| !data.stuConsentFileURL">
                          <v-file-input
                              ref="consentFile"
                              v-model="consentFile"
                              :label="$t('ADMISSION_DATA.STEP2.CONSENT_FILE')"
                              :placeholder="
                              $t('ADMISSION_DATA.STEP2.CONSENT_FILE')
                            "
                              :rules="consentFileRule"
                              :show-size="1000"
                              accept="*/*"
                              color="primary"
                              outlined
                              prepend-icon="mdi-paperclip"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                  v-if="index < 2"
                                  color="primary"
                                  dark
                                  label
                                  small
                              >
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-template>
                        <v-template v-else>
                          <legend class="grey--text pb-1">
                            {{ $t("ADMISSION_DATA.STEP2.CONSENT_FILE") }}
                          </legend>
                          <a ref="#">consent file...</a>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                  class="ms-3"
                                  color="error"
                                  meduim
                                  @click="deleteImage('consentFile')"
                                  v-on="on"
                              >mdi-delete
                              </v-icon>
                            </template>
                            <span>{{ $t("ADMISSION_DATA.UPLOAD_IMG") }}</span>
                          </v-tooltip>
                          <v-divider class="mt-2"></v-divider>
                        </v-template>
                      </v-col>


                      <!--  صورة اثبات الاقامه لولى الامر والطالب  -->
                      <v-col v-if="hasSubCertificateType" cols="6" lg="4">
                        <v-template
                            v-if="
                            stuResidenceDelete || !data.stuResidenceImageURL
                          "
                        >
                          <v-file-input
                              ref="stuResidenceImage"
                              v-model="stuResidenceImage"
                              :label="
                              $t('ADMISSION_DATA.STEP2.STU_RESIDENCE_IMAGE')
                            "
                              :placeholder="
                              $t('ADMISSION_DATA.STEP2.STU_RESIDENCE_IMAGE')
                            "
                              :rules="imageRule"
                              :show-size="1000"
                              accept="image/*"
                              color="primary"
                              outlined
                              prepend-icon="mdi-paperclip"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                  v-if="index < 2"
                                  color="primary"
                                  dark
                                  label
                                  small
                              >
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-template>
                        <v-template v-else>
                          <legend class="grey--text pb-1">
                            {{ $t("ADMISSION_DATA.STEP2.STU_RESIDENCE_IMAGE") }}
                          </legend>
                          <a ref="#" @click="previewImage('stuResidence')"
                          >student residence...</a
                          >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                  class="ms-3"
                                  color="error"
                                  meduim
                                  @click="deleteImage('stuResidence')"
                                  v-on="on"
                              >mdi-delete
                              </v-icon>
                            </template>
                            <span>{{ $t("ADMISSION_DATA.UPLOAD_IMG") }}</span>
                          </v-tooltip>
                          <v-divider class="mt-2"></v-divider>
                        </v-template>
                      </v-col>
                      <v-col v-if="hasSubCertificateType" cols="6" lg="4">
                        <v-template
                            v-if="
                            guardianResidenceDelete ||
                              !data.guardianResidenceImageURL
                          "
                        >
                          <v-file-input
                              ref="guardianResidenceImage"
                              v-model="guardianResidenceImage"
                              :label="
                              $t(
                                'ADMISSION_DATA.STEP2.LEGAL_GUARDIAN_RESIDENCE_IMAGE'
                              )
                            "
                              :placeholder="
                              $t(
                                'ADMISSION_DATA.STEP2.LEGAL_GUARDIAN_RESIDENCE_IMAGE'
                              )
                            "
                              :rules="imageRule"
                              :show-size="1000"
                              accept="image/*"
                              color="primary"
                              outlined
                              prepend-icon="mdi-paperclip"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                  v-if="index < 2"
                                  color="primary"
                                  dark
                                  label
                                  small
                              >
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-template>
                        <v-template v-else>
                          <legend class="grey--text pb-1">
                            {{
                              $t(
                                  "ADMISSION_DATA.STEP2.LEGAL_GUARDIAN_RESIDENCE_IMAGE"
                              )
                            }}
                          </legend>
                          <a ref="#" @click="previewImage('guardianResidence')"
                          >guardian residence...</a
                          >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                  class="ms-3"
                                  color="error"
                                  meduim
                                  @click="deleteImage('guardianResidence')"
                                  v-on="on"
                              >mdi-delete
                              </v-icon>
                            </template>
                            <span>{{ $t("ADMISSION_DATA.UPLOAD_IMG") }}</span>
                          </v-tooltip>
                          <v-divider class="mt-2"></v-divider>
                        </v-template>
                      </v-col>

                    </v-row>
                    <v-row
                        v-if="hasSubCertificateType"
                        :class="
                        $vuetify.breakpoint.xs
                          ? 'justify-center'
                          : 'mx-7 justify-start'
                      "
                    >
                      برجاء تحميل جميع الشهادات المطلوبه فى صيغة pdf لحساب المجموع الاعتباري
                    </v-row>
                    <v-col
                        v-if="data.pullFromGsApi!==true && data.preQualYearHRId && data.certificateType
                      && [16,77].includes(data.certificateType) && data.cardID "
                        cols="12" lg="4">
                     <span :class="`${statusColor}--text font-weight-bold`">
                      {{ statusLabel }}
                    </span>
                    </v-col>

                    <v-row
                        :class="
                        $vuetify.breakpoint.xs
                          ? 'justify-center'
                          : 'mx-7 justify-end'
                      "
                    >
                      <v-btn class="ma-2 pa-0" color="error" @click="cancel()">
                        {{ $t("CANCEL") }}
                      </v-btn>
                      <v-btn class="ma-2 pa-0" @click="backStep(2)">
                        {{ $t("ADMISSION_DATA.BACK") }}
                      </v-btn>
                      <v-btn
                          ref="nextToSelectFac"
                          class="ma-2 pa-0"
                          color="primary"
                          @click="nextStep(2)"
                      >
                        {{ $t("ADMISSION_DATA.NEXT") }}
                      </v-btn>
                    </v-row>
                  </v-stepper-content>
                </v-form>

                <!-----------------------------------End Step2------------------------------------------->
                <!-----------------------------Step3------------------------------------------------->
                <v-form ref="stepForm3">
                  <v-stepper-content step="3">
                    <v-row>
                      <v-col cols="12">
                        <!--<p class="font-weight-black">-->
                        <p>
                          {{ $t("ADMISSION_DATA.STEP3.MESSAGE") }}
                        </p>
                      </v-col>

                      <v-col cols="12" lg="4">
                        <v-chip class="ma-2" color="secondary">
                          {{
                            $t("ADMISSION_DATA.STEP3.ACDYEAR") +
                            " : " +
                            data.currentYearName
                          }}
                        </v-chip>
                        <v-chip class="ma-2" color="secondary">
                          {{ $t("ADMISSION_DATA.STEP3.SEMESTER") + " : " }}
                          {{
                            data.currentSemName
                                ? serverTranslate(data.currentSemName)
                                : ""
                          }}
                        </v-chip>
                      </v-col>
                      <v-col
                          v-for="(selection, index) in (data.numSelectionToDraw)"
                          :key="index"
                          cols="12"
                          lg="3"
                      >
                        <v-autocomplete
                            :key="`faculty-select-${index}-${facultySelections[index]}`"
                            v-model="facultySelections[index]"
                            :disabled="(index > 0 && !facultySelections[index - 1]) || disabledSelections[index] && ! applicationID"
                            :items="getFacultyItems(index)"
                            :label="`${$t('ADMISSION_DATA.STEP3.DESIRE')} ${(!data.appStatus?data.loopIndex +index:data.currAppDesireNum)}`"
                            :rules="[requiredOneNonDisabledRule]"
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="facultyChange(index, facultySelections[index])"
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title
                                  v-html="serverTranslate(data.item.name)"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>

                      </v-col>
                      <v-col
                          v-if="
                          facultyBranches
                            ? facultyBranches.length > 0
                              ? requiredRules
                              : false
                            : false
                        "
                          cols="12"
                          lg="3"
                      >
                        <v-autocomplete
                            v-model="data.requestBranch"
                            :disabled="data.appStatus > '0' ? true : false"
                            :items="facultyBranches"
                            :label="$t('ADMISSION_DATA.STEP3.BRANCH')"
                            :rules="requiredRules"
                            item-text="name"
                            item-value="id"
                            outlined
                        >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs">
                              {{ serverTranslate(data.item.name) }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item === 'object'">
                              <v-list-item-content>
                                <v-list-item-title
                                    v-html="serverTranslate(data.item.name)"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col class="mx-2" cols="12">
                        <v-checkbox
                            v-model="checkbox"
                            :label="$t('ADMISSION_DATA.STEP3.CHECK')"
                            :rules="requiredRules"
                            class="d-inline-block my-2"
                        ></v-checkbox>
                        <v-btn
                            class="d-inline-block pb-3 text-decoration-underline"
                            color="primary"
                            small
                            text
                            @click="openTerms = !openTerms"
                        >{{ $t("ADMISSION_DATA.STEP3.TERMS") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                        :class="
                        $vuetify.breakpoint.xs
                          ? 'd-flex justify-center'
                          : 'mx-7 justify-end'
                      "
                    >
                      <v-btn class="ma-2 pa-0" color="error" @click="cancel()">
                        {{ $t("CANCEL") }}
                      </v-btn>
                      <v-btn class="ma-2 pa-0" @click="backStep(3)">
                        {{ $t("ADMISSION_DATA.BACK") }}
                      </v-btn>
                      <v-btn
                          :disabled="isSubmitting"
                          v-if="(data.appStatus === '4' && data.checkPayment===0 )
                            ||(data.appStatus === '4' && data.checkPayment===1
                            && (paymentData.paymentStatus === 1||data.paymentReceiptImageURL && data.feesRules==={}))"
                          class="ma-2 pa-2"
                          color="primary"
                          @click="(data.appStatus === '4' && data.checkPayment===0)?submit('7'):submit('1')"
                      >
                        {{ $t("ADMISSION_DATA.SAVE") }}
                      </v-btn>

                      <v-btn
                          v-if="!data.appStatus
                        || data.appStatus === '0'|| data.appStatus === '-2'
                        || (data.appStatus==='4' && data.checkPayment===0)
                        || (data.appStatus==='4' && data.feesRules.value2 ==='receipt')
                        || (data.appStatus==='4' && data.checkPayment===1
                            && (paymentData.paymentStatus!== 1&&!data.paymentReceiptImageURL))"
                          class="ma-2 pa-0"
                          color="primary"
                          @click="nextStep(3)"
                      >
                        {{ $t("ADMISSION_DATA.NEXT") }}
                      </v-btn>
                    </v-row>
                  </v-stepper-content>
                </v-form>
                <!-----------------------------End Step3------------------------------------------------->
              </template>
              <!-----------------------------Step4------------------------------------------------->
              <v-form ref="stepForm4">
                <v-stepper-content step="4">
                  <v-row>
                    <v-col cols="12">
                      <div>
                        <v-template v-if="paymentData.paymentStatus === 1">
                          <v-col cols="12">
                            {{
                              $t("ADMISSION_DATA.STEP4.HAS_REFRENCE_PAID", {
                                paymentNum: paymentData.feesData.paymentNum
                              })
                            }}
                          </v-col>
                        </v-template>

                        <v-template v-else>
                          {{ data.feesData }}
                          <v-col v-if="data.feesRules && data.feesRules.value3==='fawry'" cols="12">
                            <span class="d-flex font-weight-black">
                              {{ $t("ADMISSION_DATA.STEP4.LINE1") }}
                              {{ data.appliedFeesValue }}
                              {{ $t("ADMISSION_DATA.STEP4.LINE1CONT") }}
                            </span>
                            <div class="ms-3">
                              <span>{{
                                  $t("ADMISSION_DATA.STEP4.ONLINE_PAYMENT")
                                }}</span>
                              <span
                                  class="ms-3 primary--text pointer"
                                  @click="openPaymentLink"
                              >{{
                                  $t("ADMISSION_DATA.STEP4.CLICK_HERE")
                                }}</span
                              >
                            </div>
                            <span class="d-flex font-weight-black">
                              {{ $t("ADMISSION_DATA.STEP4.LINE2") }}
                            </span>
                            <span class="d-flex font-weight-black">
                              {{ $t("ADMISSION_DATA.STEP4.LINE3") }}
                            </span>
                            <span class="d-flex font-weight-black">
                              {{ $t("ADMISSION_DATA.STEP4.LINE4") }}
                            </span>
                            <span class="blue--text">
                              {{ $t("ADMISSION_DATA.STEP4.LINE5") }}
                            </span
                            ><br/>
                            <span class="blue--text">
                              {{ $t("ADMISSION_DATA.STEP4.LINE6") }}
                            </span
                            ><br/>
                            <span class="blue--text">
                              {{ $t("ADMISSION_DATA.STEP4.LINE7") }}
                            </span>
                          </v-col>
                          <v-col v-if=" data.feesRules.value2 !=='receipt'
                                        && (data.feesRules && data.feesRules.value3==='bank'
                                        ||(data.appStatus !== '1' && data.appStatus&& data.checkPayment!==0 ))
                                         && !(data.feesRules && data.feesRules!==''
                                         && data.stuApplicationsFact.length<data.allowedDesiresCount
                                         && data.stuApplicationsFact.length>0
                                         && data.checkOnePaid)
                                         "
                                 cols="12">

                            <span v-if="data.feesRules.value3!=='fawry' " class="d-flex font-weight-black">
                              {{ $t("ADMISSION_DATA.STEP4.LINE1") }}
                            </span>
                            <div v-if="data.feesRules.value3!=='fawry' " class="ms-3">
                              <span>{{
                                  $t("ADMISSION_DATA.STEP4.ONLINE_PAYMENT")
                                }}</span>
                              <span v-if="data.feesRules.value3!=='fawry' "
                                    class="ms-3 primary--text pointer"
                                    @click="openPaymentLink"
                              >{{
                                  $t("ADMISSION_DATA.STEP4.CLICK_HERE")
                                }}</span
                              >
                            </div>
                          </v-col>

                          <v-col
                              v-if="
                              paymentData.paymentStatus === 0 &&
                                paymentData.feesData.paymentDate
                            "
                              cols="8"
                          >
                            {{
                              $t("ADMISSION_DATA.STEP4.HAS_REFRENCE_NOT_PAID", {
                                paymentNum: paymentData.feesData.paymentNum,
                                paymentDate: paymentData.feesData.paymentDate
                              })
                            }}
                            <span
                                class="ms-3 primary--text pointer"
                                @click="openPaymentLink"
                            >{{ $t("ADMISSION_DATA.STEP4.CLICK_HERE") }}</span
                            >
                          </v-col>

                          <template
                              v-else-if="
                              [0, 2].includes(paymentData.paymentStatus)
                            "
                          >
                            <v-col
                                v-if="paymentData.paymentStatus === 2"
                                cols="12"
                            >
                              {{
                                $t("ADMISSION_DATA.STEP4.EXPIRED", {
                                  paymentNum: paymentData.feesData.paymentNum
                                })
                              }}
                            </v-col>
                          </template>


                          <v-row v-if="data.appStatus !== '7' && data.feesRules.value2==='receipt' ">
                            <v-col cols="4" lg="4">
                              <v-template v-if=" paymentReceiptDelete ||!data.paymentReceiptImageURL ">
                                <v-file-input
                                    ref="paymentReceiptImage"
                                    v-model="paymentReceiptImage"
                                    :label="$t('ADMISSION_DATA.STEP2.RECEIPT_IMAGE')"
                                    :placeholder="$t('ADMISSION_DATA.STEP2.RECEIPT_IMAGE')"
                                    :rules="requiredRules"
                                    :show-size="1000"
                                    accept="image/*"
                                    color="primary"
                                    outlined
                                    prepend-icon="mdi-paperclip"
                                >
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip
                                        v-if="index < 2"
                                        color="primary"
                                        dark
                                        label
                                        small
                                    >
                                      {{ text }}
                                    </v-chip>
                                  </template>
                                </v-file-input>
                              </v-template>
                              <v-template v-else>
                                <legend class="grey--text pb-1">
                                  {{ $t("ADMISSION_DATA.STEP2.RECEIPT_IMAGE") }}
                                </legend>
                                <a
                                    ref="#"
                                    @click="previewImage('paymentReceipt')"
                                >receipt image...</a
                                >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                        class="ms-3"
                                        color="error"
                                        meduim
                                        @click="deleteImage('paymentReceipt')"
                                        v-on="on"
                                    >mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>{{
                                      $t("ADMISSION_DATA.UPLOAD_IMG")
                                    }}</span>
                                </v-tooltip>
                                <v-divider class="mt-2"></v-divider>
                              </v-template>
                            </v-col>

                            <v-col cols="4" lg="4">
                              <v-text-field
                                  ref="referenceNum"
                                  v-model="data.referenceNum"
                                  :label="$t('ADMISSION_DATA.STEP4.RECEIPTNUM')"
                                  :rules="referenceNumRules"
                                  clearable
                                  counter="30"
                                  maxlength="30"
                                  outlined
                                  @keydown.space="preventLeadingSpace"
                              ></v-text-field>
                            </v-col>

                          </v-row>


<!--                          <div v-if="data.feesRules !== {} && data.feesRules&& data.feesRules.value3==='fawry' ">-->
<!--                            <span class="font-weight-black"-->
<!--                            >{{-->
<!--                                $t("ADMISSION_DATA.STEP4.TECHNICAL_SUPPORT")-->
<!--                              }}-->
<!--                              {{ paymentData.supportNumbers }}</span-->
<!--                            >-->
<!--                          </div>-->

                        </v-template>


                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                      :class="
                        $vuetify.breakpoint.xs
                          ? 'd-flex justify-center'
                          : 'mx-7 justify-end'
                      "
                  >
                    <v-btn class="ma-2 pa-0" color="error" @click="cancel()">
                      {{ $t("CANCEL") }}
                    </v-btn>

                    <v-btn
                        v-if="data.appStatus != '7'"
                        :class="$vuetify.breakpoint.xs ? 'ms-11' : ''"
                        class="ma-2 pa-0"
                        @click="backStep(4)"
                    >
                      {{ $t("ADMISSION_DATA.BACK") }}
                    </v-btn>

                    <v-btn
                        :disabled="isSubmitting"
                        v-if="(!data.appStatus || data.appStatus in ['0','-2'])
                          && !(data.feesRules && data.feesRules!==''
                               && data.stuApplicationsFact.length<data.allowedDesiresCount
                               && data.stuApplicationsFact.length>0
                               && data.checkOnePaid) "
                        class="ma-2 pa-2"
                        color="primary"
                        @click="[0,'0'].includes(data.initialApplyPeriodCheck)?submit('0'):submit('-2')"
                    >
                      {{ $t("ADMISSION_DATA.DRAFT") }}
                    </v-btn>

                    <v-btn
                        :disabled="isSubmitting"
                        v-if="((!data.appStatus || data.appStatus==='' ||(data.appStatus && data.feesRules.value2==='receipt'))
                                &&(!data.feesRules || data.feesRules===''||data.feesRules.value2==='receipt')
                                )
                             ||( ['4','0','-2'].includes(data.appStatus)&&data.checkPayment === 0)
                             || (data.feesRules && data.feesRules!==''
                             && data.stuApplicationsFact.length<data.allowedDesiresCount
                             && data.stuApplicationsFact.length>0
                             && data.checkOnePaid)"
                        class="ma-2"
                        color="primary"
                        @click="data.checkPayment === 0 ? submit('7') : submit('1')"
                    >
                      {{ $t("ADMISSION_DATA.SAVE") }}
                    </v-btn>

                  </v-row>
                </v-stepper-content>
              </v-form>
              <!-----------------------------End Step4------------------------------------------------->
            </v-stepper-items>
            <!-----------------------------STEPPER End CONTENT------------------------------------------------->
          </template>
        </v-stepper>
        <!-----------------------------STEPPER END------------------------------------------------->
      </v-col>
    </v-row>
    <ad-Terms
        v-if="openTerms"
        :on="openTerms"
        @change="openTerms = $event"
    ></ad-Terms>
    <ad-confirmDialog ref="confirm"></ad-confirmDialog>
    <ad-show-files
        v-if="showImage"
        :key="componentKey"
        :src="imageSrc"
    ></ad-show-files>
  </v-container>
</template>

<script>
import Terms from "./TremsAndCondition.vue";
import serverTranslationsMixin from "@/mixins/serverTranslations";
import generalFunctions from "@/mixins/generalFunctions";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ImagePreview from "./ImagePreview";
import {type} from "os";
import Swal from "sweetalert2";

export default {
  name: "ad-Stepper",
  components: {
    "ad-Terms": Terms,
    "ad-confirmDialog": ConfirmDialog,
    "ad-show-files": ImagePreview
  },
  mixins: [serverTranslationsMixin, generalFunctions],
  data() {
    return {
      isSubmitting: false,
      savedCertificate: '',
      savedPrequalYear: '',
      showNextBtn: true,
      initialLoad: true,
      statusLabel: '',
      statusColor: '',
      pullStatus: 1,
      stepper: {
        currentStep: 1,
        steps: 3,
        vertical: false,
        altLabels: true,
        editable: false
      },
      showImage: false,
      openTerms: false,
      hasSubCertificate: false,
      hasSubCertificateType: false,
      hasAnthorCertificate: false,
      imageSrc: "",
      pickerMenu: false,
      bindProps: {
        mode: "international",
        defaultCountry: "EG",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: this.$t("ADMISSION_DATA.STEP1.PHONE"),
        required: true,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["EG"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "on",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "success--text",
        customValidate: false,
        regionCode: "EG",
        dropdownOptions: {
          disabledDialCode: true
        },
        inputOptions: {
          showDialCode: false
        },
        international: ""
      },
      data: {
        arName: "",
        enName: "",
        email: "",
        cardID: "",
        cardType: 1,
        mobile: "",
        telephone: "",
        gender: 13,
        religion: 84,
        dOB: "",
        countriesList: [],
        addressStatesList: [],
        addressCitiesList: [],
        birthStatesList: [],
        birthCitiesList: [],
        total: "",
        percentage: "",
        preQualYearHRId: "",
        preQualYear: "",
        PreQualYearRules: '',
        pullFromGsApi: false,
        studentSecondaryData: '',
        currentSemId: "",
        currentSemName: "",
        requestFac: "",
        years: [],
        certificateTypes: [],
        egyptianCertificates: [],
        certificateType: "",
        equationCertificateTypes: [],
        equationCertificateType: "",
        foreignCertificate: "",
        otherCertificateText: "",
        addressCountry: "",
        addressState: "",
        addressCity: "",
        birthPlaceCountry: "",
        birthPlaceState: "",
        birthPlaceCity: "",
        openedFaculities: [],
        requestBranch: "",
        appStatus: "",
        uid: "",
        cardImageURL: "",
        birthCertUrl: "",
        guardianCardUrl: "",
        militaryFormUrl: "",
        certificateImageURL: "",
        preQualFileURL: "",
        stuConsentFileURL: "",
        consentFileDownloadURL: "",
        paymentReceiptImageURL: "",
        stuResidenceImageURL: "",
        guardianResidenceImageURL: "",
        personalImageURL: "",
        divisionType: "",
        preQualCountry: "",
        checkPayment: 0,
        appliedFeesValue: '',
        currentAppStatus: '',
        feesRules: {},
        initialApplyPeriodCheck: 0,
        admissionRules: [],
        allowedDesiresCount: 1,
        stuApplications: [],
        stuAppsCount: 0,
        stuApplicationsFact: [],
        checkOnePaid: 0,
        loopIndex: 0,
        appId: '',
        numSelectionToDraw: 0,
        currAppDesireNum: 1,
        referenceNum: null
      },
      allOpenedFaculties: [],
      facultySelections: [],
      disabledSelections: [],
      facultyBranches: [],
      divisionTypes: [],
      allowDisabled: true,
      cardImage: null,
      birthCert: null,
      guardianCard: null,
      personalImage: null,
      certificatesFile: null,
      consentFile: null,
      paymentReceiptImage: null,
      anotherCertificateImage: null,
      anotherCertificateImage3: null,
      stuResidenceImage: null,
      guardianResidenceImage: null,
      militaryForm: null,
      cardDeleted: false,
      birthCertDeleted: false,
      guardianCardDeleted: false,
      militaryFormDeleted: false,
      certificateImageDeleted: false,
      personalImgDelete: false,
      certifcateFileDelete: false,
      consentFileDelete: false,
      paymentReceiptDelete: false,
      certifcate2Delete: false,
      certifcateDelete3: false,
      stuResidenceDelete: false,
      guardianResidenceDelete: false,
      componentKey: 0,
      checkbox: !this.$route.params.id ? false : true,
      paymentLink: "",
      applicationID: this.$route.params.id,
      paymentData: {
        paymentStatus: 0,
        supportNumbers: "",
        univId: "",
        univHrId: "",
        studentId: "",
        feesData: {paymentNum: "", paymentDate: "", value: ""}
      }

    };
  },
  watch: {
    "data.foreignCertificate"(newVal, oldVal) {
      if (oldVal) this.data.otherCertificateText = "";
      this.hasAnthorCertificate = this.data.foreignCertificate == 32;
    },
    "stepper.vertical"() {
      this.stepper.currentStep = 2;
      requestAnimationFrame(() => (this.stepper.currentStep = 1)); // Workarounds
    },
    "data.certificateType"() {
      if (![16, 77].includes(this.data.certificateType)) {
        this.$refs.nextToSelectFac.$el.style.display = "";
      }
      if (this.data.certificateType == 17) {
        //if Equivalent certificate
        this.hasSubCertificateType = true;
      } else {
        this.data.preQualCountry = 1; // return to egypt
        this.hasSubCertificateType = false;
        this.data.equationCertificateType = "";
        this.data.otherCertificateText = "";
        this.data.foreignCertificate = "";
        this.hasAnthorCertificate = false;
      }

      /*scientific->18, literary->19,Scientific science->20,Mathematics science->20, */
      this.divisionTypes = this.data.divisionTypes.filter(
          item =>
              (this.data.certificateType === 15 && [18, 19].indexOf(item.id) > -1) ||       //Azhari secondary school
              ([77, 16].includes(this.data.certificateType) &&  [19, 20, 21].indexOf(item.id) > -1) || //General secondary school
              (this.data.certificateType === 17 &&[18, 19].indexOf(item.id) > -1) ||        // Equivalent certificate
              (this.data.certificateType === 62 && [63, 64, 81].indexOf(item.id) > -1) ||   // fanya certificate
              (this.data.certificateType === 78 && [63, 64, 80].indexOf(item.id) > -1)  ||    // togary certificate
              (this.data.certificateType === 83 && [63].indexOf(item.id) > -1)      // betrol certificate
      );
      if (!this.divisionTypes.find(item => item.id == this.data.divisionType))
        this.data.divisionType = "";
    },
    "data.equationCertificateType"() {
      //if english
      this.hasSubCertificate =
          this.data.equationCertificateType == 22 ||
          this.data.equationCertificateType == 61;
      if (this.data.equationCertificateType == 23) {
        //reset sub selection
        this.data.otherCertificateText = "";
        this.data.foreignCertificate = "";
      }
    },
    direction: function () {
      this.bindProps.placeholder = this.$t("ADMISSION_DATA.STEP1.PHONE");
      if (this.$refs.stepForm1.$el.querySelector(".error--text")) {
        this.$refs.stepForm1.validate();
      }
      if (this.$refs.stepForm2.$el.querySelector(".error--text")) {
        this.$refs.stepForm2.validate();
      }
      if (this.$refs.stepForm3.$el.querySelector(".error--text")) {
        this.$refs.stepForm3.validate();
      }
    }
  },

  computed: {
      selectedPreQualYear: {
    get() {
      return (this.data.preQualYearHRId?this.data.preQualYearHRId: this.data.preQualYear)
    },
    set(val) {
      this.data.preQualYearHRId = val

      const selected = this.data.years.find(y => y.hrId === val)
      if (selected) {
        this.data.preQualYear = selected.id
      }
    }
  }
  ,
    filteredPreQualYears() {
      if (!this.data.PreQualYearRules) return this.data.years;

      const allowedHrIds = this.data.PreQualYearRules
          .split(',')
          .map(v => v.trim())
          .filter(v => v);

      return this.data.years.filter(
          y => allowedHrIds.includes(y.hrId)
      );
    },
    requiredOneNonDisabledRule: function () {
      const hasAtLeastOne = this.facultySelections.some((val, i) => {
        return !this.disabledSelections[i] && val != null && val !== '';
      });
      return hasAtLeastOne || this.data.appStatus !== '' || this.$t("REQUIRED_FIELD");
    },
    direction: function () {
      return this.$store.state.direction;
    },
    locale() {
      return this.$store.state.curLanguage;
    },
    arNameRules() {
      return this.$store.state.rules.arNameRules;
    },
    enNameRules() {
      return this.$store.state.rules.enNameRules;
    },
    requiredRules() {
      return this.$store.state.rules.requiredRule;
    },
    phoneRules() {
      return this.$store.state.rules.phoneRules;
    }
    , referenceNumRules() {
      return this.$store.state.rules.refNumRules;
    },
    cardImageRule() {
      if (
          this.cardImage || this.personalImage &&
          (event.target.files[0].type.indexOf("image/") !== 0 ||
              event.target.files[0].type.indexOf("image/tiff") === 0)
      ) {
        return this.$store.state.rules.photoRules;
      }
      return [
        this.$store.state.rules.required,
        this.$store.state.rules.fileField
      ];
    },
    birthCertRule() {
      if (
          this.birthCert &&
          (event.target.files[0].type.indexOf("image/") !== 0 ||
              event.target.files[0].type.indexOf("image/tiff") === 0)
      ) {
        return this.$store.state.rules.photoRules;
      }
      return [
        this.$store.state.rules.required,
        this.$store.state.rules.fileField
      ];
    },
    guardianCardRule() {
      if (
          this.guardianCard &&
          (event.target.files[0].type.indexOf("image/") !== 0 ||
              event.target.files[0].type.indexOf("image/tiff") === 0)
      ) {
        return this.$store.state.rules.photoRules;
      }
      return [
        this.$store.state.rules.required,
        this.$store.state.rules.fileField
      ];
    },
    militaryFormRule() {
      if (
          this.militaryForm &&
          (event.target.files[0].type.indexOf("image/") !== 0 ||
              event.target.files[0].type.indexOf("image/tiff") === 0)
      ) {
        return this.$store.state.rules.photoRules;
      }
      return [
        this.$store.state.rules.fileField
      ];
    },
    imageRule() {
      if (
          this.personalImage &&
          (event.target.files[0].type.indexOf("image/") !== 0 ||
              event.target.files[0].type.indexOf("image/tiff") === 0)
      ) {
        return this.$store.state.rules.photoRules;
      }
      return [
        this.$store.state.rules.required,
        this.$store.state.rules.fileField
      ];
    },
    certificatesFileRule() {
      if ([0, '0'].includes(this.data.initialApplyPeriodCheck) || this.data.appStatus === '4') {
        if (this.certificatesFile) {
          return this.$store.state.rules.pdfRules; // already an array
        }
        return [this.$store.state.rules.required]; // wrap single rule string
      }
      return [true]; // return array as Vuetify expects
    }, consentFileRule() {
      if (this.consentFile) {
        return this.$store.state.rules.pdfRules; // already an array
      }
      return [this.$store.state.rules.required]; // wrap single rule string
    },
    requiredImageRule() {
      return [
        this.$store.state.rules.photoRules,
        this.$store.state.rules.required
      ];
    },
    totalDegreeRules() {
      if ([0, '0'].includes(this.data.initialApplyPeriodCheck) || this.data.appStatus === '4') {
        if ([16, 77].includes(this.data.certificateType)) {
          return this.data.total
              ? [
                v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MIN"),
                v => (v && v <= 410) || this.$t("UserData.CERTIFICATE_Egy_MAX")
              ]
              : [this.$store.state.rules.required];
        } else {
          return this.data.total
              ? [
                v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MIN"),
                v => (v && v <= 9999) || this.$t("UserData.CERTIFICATE_RESULT_MAX")
              ]
              : [this.$store.state.rules.required];
        }
      }
      return true
    },
    globalPercRule() {
      const rules = [];
      if ([0, '0'].includes(this.data.initialApplyPeriodCheck))
          rules.push(this.$store.state.rules.required);
      if (this.data.percentage) {
        if ([15, 16, 77].includes(this.data.certificateType)) {
          rules.push(
              v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_PERC_GS_MAX"),
              v => (v && v <= 100) || this.$t("ADMISSION_DATA.STEP2.TOTAL_PERC_GS_MAX")
          );
        } else {
          rules.push(
              v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MIN"),
              v => (v && v <= 200) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MAX")
          );
        }
      }
      return rules;
    },
    // percentageRules() {
    //   const rules = [];
    //   rules.push(this.$store.state.rules.required);
    //   if (this.data.percentage) {
    //     rules.push(
    //         v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MIN"),
    //         v => (v && v <= 200) || this.$t("ADMISSION_DATA.STEP2.TOTAL_MAX")
    //     );
    //   }
    //
    //   return rules;
    // },
    // percentageGsRules() {
    //   const rules = [];
    //   rules.push(this.$store.state.rules.required);
    //   if (this.data.percentage) {
    //     rules.push(
    //         v => (v && v > 0) || this.$t("ADMISSION_DATA.STEP2.TOTAL_PERC_GS_MAX"),
    //         v => (v && v <= 100) || this.$t("ADMISSION_DATA.STEP2.TOTAL_PERC_GS_MAX")
    //     );
    //   }
    //
    //   return rules;
    // },


    otherCertificateTextRules() {
      return this.$store.state.rules.otherCertificateRules(
          this.data.foreignCertificate
      );
    }
  },
  mounted() {

    this.facultySelections = Array(this.data.allowedDesiresCount).fill(null);
    const request = this.applicationID
        ? this.$http.post("/api/applications/edit_applications/", {
          applicationID: this.applicationID,
          initialApplyPeriodCheck: this.data.initialApplyPeriodCheck
        })
        : this.$http.post("/api/students_data/get_profile_data/", {'userProfile': 'false'});

    request.then(
        res => {
          Object.assign(this.data, res.data.data);
          this.savedCertificate = res.data.data.certificateType
          this.savedPrequalYear = res.data.data.preQualYearHRId
          this.allOpenedFaculties = res.data.data.openedFaculities
          this.facultyBranches = this.data.branches;
          this.stepper.currentStep = (this.data.appStatus !== "7" ? 1 : 4);
          this.data.appStatus !== "7" ? this.getPaymentData() : "";

          if (!this.applicationID) {
            const existingDesires = (this.data.stuApplications || [])
              .map(app => parseInt(app.desire_num))
              .filter(num => !isNaN(num));
            this.data.loopIndex = existingDesires.length
              ? Math.max(...existingDesires) + 1
              : 1;
          }
          // this.data.loopIndex = (this.data.stuAppsCount < this.data.allowedDesiresCount ? 1 : this.data.stuAppsCount + 1)

          if (this.data.preQualYearHRId && this.data.PreQualYearRules) {
            const allowedHrIds = this.data.PreQualYearRules
                .split(',')
                .map(v => v.trim())
                .filter(Boolean);

            // هل السنة المختارة ضمن السنوات المسموحة؟
            const existsInAllowedYears = this.data.years.some(
                y => allowedHrIds.includes(y.hrId) && y.hrId === this.data.preQualYearHRId
            );

            if (!existsInAllowedYears) {
              this.data.preQualYearHRId = '';
              this.data.preQualYear = '';
            }
          }
          this.initializeFacultySelections();
        },
        err => {
          this.showToasted("error", err.response.data.message);
          this.$router.push({name: "ListApplications"});
        }
    );
  },
  methods: {
    type,
    validateDesireSequence() {
  for (let i = 1; i < this.facultySelections.length; i++) {
    if (this.facultySelections[i] && !this.facultySelections[i - 1]) {
      this.showToasted(
        "error",
        `Please select Desire ${i} before Desire ${i + 1}.`
      );
      return false;
    }
  }
  return true;
},
    getFacultyItems(index) {
      return this.disabledSelections[index]
          ? this.data.openedFaculities
          : this.data.openedFaculities.filter(fac => !this.facultySelections.some((id, i) => this.disabledSelections[i] && id === fac.id));
    },
    initializeFacultySelections() {
      if (this.data.stuAppsCount < this.data.allowedDesiresCount && this.data.stuAppsCount > 0) {

        const filled = this.data.stuApplications.map(app => app['app_faculty']['app_fac_id']);
        const total = this.data.allowedDesiresCount;
        this.facultySelections = Array(total).fill(null);
        this.disabledSelections = Array(total).fill(false);
        for (let i = 0; i < filled.length; i++) {
          this.facultySelections[i] = filled[i];
          this.disabledSelections[i] = true;
        }
      }

    },
    getFoundation() {
      return localStorage.getItem("foundationId");
    },
    downloadFile() {
      const src = this.data.consentFileDownloadURL
      const link = document.createElement('a');
      link.href = src;
      link.download = this.data.consentFileDownloadURL.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    ChangeCountry(type = "address") {
      let cond = true;
      let param = {};
      if (type === "address") {
        this.data.addressState = this.data.addressCity = null;
        this.data.addressStatesList = this.data.addressCitiesList = [];
        cond = this.data.addressCountry;
        param = {countryId: this.data.addressCountry};
      } else if (type === "birthPlace") {
        this.data.birthPlaceState = this.data.birthPlaceCity = null;
        this.data.birthStatesList = this.data.birthCitiesList = [];
        cond = this.data.birthPlaceCountry;
        param = {countryId: this.data.birthPlaceCountry};
      }

      if (cond) {
        this.$http.post("/api/regions_data/get_states/", param).then(
            res => {
              res = res.data;
              if (type === "address") {
                this.data.addressStatesList = res.data.map(item => {
                  return {id: item.id, name: item.name};
                });
              } else if (type === "birthPlace") {
                this.data.birthStatesList = res.data.map(item => {
                  return {id: item.id, name: item.name};
                });
              }
            },
            err => {
              this.showToasted("error", err.response.data.message);
            }
        );
      }
    },
    ChangeState(type = "address") {
      let cond = true;
      let param = {};
      if (type === "address") {
        this.data.addressCity = null;
        this.data.addressCitiesList = [];
        cond = this.data.addressState;
        param = {
          countryId: this.data.addressCountry,
          stateId: this.data.addressState
        };
      } else if (type === "birthPlace") {
        this.data.birthPlaceCity = null;
        this.data.birthCitiesList = [];
        cond = this.data.birthPlaceState;
        param = {
          countryId: this.data.birthPlaceCountry,
          stateId: this.data.birthPlaceState
        };
      }
      if (cond) {
        this.$http.post("/api/regions_data/get_cities/", param).then(
            res => {
              res = res.data;
              if (type === "address") {
                this.data.addressCitiesList = res.data.map(item => {
                  return {id: item.id, name: item.name};
                });
              } else if (type === "birthPlace") {
                this.data.birthCitiesList = res.data.map(item => {
                  return {id: item.id, name: item.name};
                });
              }
            },
            err => {
              this.showToasted("error", err.response.data.message);
            }
        );
      }
    },
    facultyChange(index, value) {
      this.facultyBranches = [];
      this.data.requestBranch = "";
      if (this.facultySelections.length) {
        this.data.requestFac = this.facultySelections[0]
        this.$http
            .post("/api/general_data/faculty_branches/", {
              facultyID: this.facultySelections[0]
            })
            .then(
                res => {
                  res = res.data;
                  this.facultyBranches = res.data.branches;
                },
                err => {
                  this.showToasted("error", err.response.data.message);
                }
            );
      }
      // Prevent selecting the same faculty in another dropdown
      const selectedIds = this.facultySelections.filter((_, i) => i !== index);
      if (selectedIds.includes(value) || this.data.stuApplicationsFact.includes(value)) {
        this.$set(this.facultySelections, index, null);
        this.showToasted("error", this.$t("ADMISSION_DATA.STEP3.FACULTY_CHOOSEN"));
      }
    },
    IsValid(model) {
      if (model.number.input) {
        this.bindProps.regionCode = model.regionCode;
        this.bindProps.international = model.number.international;
        if (!model.valid) this.bindProps.inputClasses = "error--text";
        else this.bindProps.inputClasses = "success-text";
      }
    },
    validateMobileInBlur() {
      if (!this.data.mobile) this.bindProps.inputClasses = "error--text";
    },
    async nextStep(n) {
      let goNext = true;
      const form =
          n === 1
              ? this.$refs.stepForm1
              : n === 2
                  ? this.$refs.stepForm2
                  : this.$refs.stepForm3;

      this.data.mobile ? "" : this.validateMobileInBlur(this.data.mobile);

      if (
          form.validate() &&
          this.data.mobile &&
          this.bindProps.inputClasses !== "error--text"
      ) {
        if (n === 3 && !this.applicationID && this.data.feesRules && this.data.feesRules.value2 === 'online'
            && !(this.data.stuApplicationsFact.length < this.data.allowedDesiresCount
                && this.data.stuApplicationsFact.length > 0 && this.data.checkOnePaid)) {

          if (n === 3 && !this.validateDesireSequence()) {
              return;
          }

          this.$refs.confirm
              .open(
                  "CONFIRMATION_MESSAGE",
                  ([0, '0'].includes(this.data.initialApplyPeriodCheck) ? "ADMISSION_DATA.STEP3.NEXT_CONFIRMATION" : "ADMISSION_DATA.STEP3.NEXT_INITIAL_CONFIRMATION"),
                  {
                    width: "410px"
                  }
              )
              .then(confirm => {
                if (confirm) {
                  const val = ([0, '0'].includes(this.data.initialApplyPeriodCheck) ? '0' : '-2')
                  this.submit(val, true).then(data => {
                    this.applicationID = data;
                    this.getPaymentData();
                  });
                }
              });
        } else if (n === 3 && this.data.feesRules && this.data.feesRules.value2 === 'online'
            && !(this.data.stuApplicationsFact.length < this.data.allowedDesiresCount
                && this.data.stuApplicationsFact.length > 0 && this.data.checkOnePaid)
        ) {
          if (n === 3 && !this.validateDesireSequence()) {
              return;
          }

          if(this.data.appStatus === "-2"){
            this.submit("-2", true).then(data => {
                this.applicationID = data;
                this.getPaymentData();
              });
          }
          else{
            this.data.appStatus === "7"
              ? this.getPaymentData()
              : this.submit("0", true).then(data => {
                this.applicationID = data;
                this.getPaymentData();
              });
          }

        }
        else if (n === 2) {
          //check GS data if exist pull it
          if ([16, 77].includes(this.data.certificateType) && this.data.pullFromGsApi !== true && this.data.preQualYearHRId ) {
            const reslt_pull = await this.$http.post("/api/users/pull_secondary_data/", {
              params: {
                cardID: this.data.cardID,
                preQualYear: this.data.preQualYear,
                certificateType: this.data.certificateType
              }
            })
            if (parseInt(reslt_pull.data.data.code) === 200) {
              goNext = true
              this.data.studentSecondaryData = reslt_pull.data.studentSecondaryData
              this.data.certificateType = reslt_pull.data.data.certificateType
              this.data.total = reslt_pull.data.data.total
              this.data.divisionType = reslt_pull.data.data.divisionTypeId
              this.data.arName = reslt_pull.data.data.name
              this.$refs.nextToSelectFac.$el.style.display = "";
              Swal.fire({
                title: 'تم سحب بيانات الثانويه العامه بنجاح',
                text: 'يمكنك الآن تسجيل رغباتك ',
                icon: 'success',
                confirmButtonText: 'موافق',
                showCancelButton: false
              }).then(() => {
                this.dialog = false;
                this.reset(true);
              })
            } else  {
              // if (parseInt(reslt_pull.data.data.code) === 404)
              goNext = false
              Swal.fire({
                title: 'بيانات الطالب غير صحيحه',
                text: 'من فضلك تأكد من الرقم القومى وعام الحصول على المؤهل ',
                icon: 'error',
                confirmButtonText: 'موافق',
                showCancelButton: false
              }).then(() => {
                this.dialog = false;
                this.reset(true);
              })
            }
            // else {
            //   goNext = false
            //   this.pullStatus = 0
            //   return false;
            //
            // }
          }
          if (this.data.admissionRules.length > 0) {
            this.data.openedFaculities = this.allOpenedFaculties
            const stuCertificateType = this.data.certificateType
            const stuCertificateMajorType = this.data.divisionType
            const facWithOutRules = this.allOpenedFaculties
                .map(rule => rule.id)
                .filter(id => !this.data.admissionRules.some(rule => rule.facultyId === id));
            let acceptedRulesFacIds = this.data.admissionRules
                .filter(rule =>
                    (rule.certificateType === stuCertificateType
                        || rule.certificateType === stuCertificateType.toString())
                    &&
                    (rule.certificateMajorTypes.includes(stuCertificateMajorType)
                        || rule.certificateMajorTypes.includes(stuCertificateMajorType.toString())
                        || (rule.certificateMajorTypes.length === 0 && !stuCertificateMajorType))
                )
                .map(rule => rule.facultyId);
            if (acceptedRulesFacIds.length > 0 || !stuCertificateMajorType) {
              if (facWithOutRules.length > 0) {
                acceptedRulesFacIds.push(...facWithOutRules)
              }
              this.data.openedFaculities = this.allOpenedFaculties
                  .filter(fac => acceptedRulesFacIds.includes(fac.id))
            } else {
              if (facWithOutRules.length > 0) {
                this.data.openedFaculities = this.allOpenedFaculties
                    .filter(fac => facWithOutRules.includes(fac.id))
              } else {
                this.data.openedFaculities = []
                this.showToasted("error", this.$t("ADMISSION_DATA.STEP3.ALL_FACULTY_CHOSEN"));
                this.$router.push({name: "ListApplications"});
              }

            }

            if (this.data.stuAppsCount >= this.data.allowedDesiresCount && this.data.stuAppsCount >= this.data.openedFaculities.length) {
              this.showToasted("error", this.$t("ADMISSION_DATA.STEP3.ALL_FACULTY_CHOSEN"));
              this.$router.push({name: "ListApplications"});
            }
            this.data.numSelectionToDraw = (this.data.openedFaculities.length >= this.data.allowedDesiresCount
                ? this.data.stuAppsCount + (this.data.allowedDesiresCount - this.data.stuAppsCount)
                : this.data.stuAppsCount + (this.data.openedFaculities.length - this.data.stuAppsCount))

            if (this.data.appStatus) {
              this.data.numSelectionToDraw = 1
              this.disabledSelections.push(this.data.requestFac)

            }
            if (this.data.numSelectionToDraw <= 0) {
              this.showToasted("error", this.$t("ADMISSION_DATA.STEP3.ALL_FACULTY_CHOSEN"));
              this.$router.push({name: "ListApplications"});
            }
            if (goNext)
              this.stepper.currentStep += 1;
          } else {
            if (this.data.appStatus) {
              const previouslySelectedFaculty = this.data.requestFac;
              this.facultySelections = [previouslySelectedFaculty];
              this.data.numSelectionToDraw = 1;
              this.disabledSelections.push(previouslySelectedFaculty)
            } else {
              const restAvalCount =    this.data.openedFaculities.length - this.data.stuAppsCount
              const remainingAllowed =    this.data.allowedDesiresCount - this.data.stuAppsCount
              const availableNewSelections =    Math.min(remainingAllowed, restAvalCount)
              // old applied + new editable
              this.data.numSelectionToDraw =    this.data.stuAppsCount + availableNewSelections
            }
            if (goNext)
              this.stepper.currentStep += 1;
          }
        }
        else if (goNext) this.stepper.currentStep += 1;

      } else {
        this.showToasted("error", this.$t("COMPLETE_DATA_ERROR"));
      }
    },
    backStep(n) {
      if (n > 1) {
        this.stepper.currentStep = n - 1;
      }
    },
    cancel() {
      this.$refs.confirm
          .open(
              "CONFIRMATION_MESSAGE",
              "ADMISSION_DATA.GO_TO_APP_LIST_CONFIRMATION",
              {
                width: "410px"
              }
          )
          .then(confirm => {
            if (confirm) {
              this.$router.push({name: "ListApplications"});
            }
          });
    },
    previewImage(value) {
      if (value === "card") {
        this.imageSrc = this.data.cardImageURL;
      } else if (value === "birthCert") {
        this.imageSrc = this.data.birthCertUrl;
      } else if (value === "guardianCard") {
        this.imageSrc = this.data.guardianCardUrl;
      } else if (value === "militaryForm") {
        this.imageSrc = this.data.militaryFormUrl;
      } else if (value === "personalImg") {
        this.imageSrc = this.data.personalImageURL;
      } else if (value === "stuResidence") {
        this.imageSrc = this.data.stuResidenceImageURL;
      } else if (value === "guardianResidence") {
        this.imageSrc = this.data.guardianResidenceImageURL;
      } else if (value === "paymentReceipt") {
        this.imageSrc = this.data.paymentReceiptImageURL;
      } else if (value === "certificateFile") {
        this.imageSrc = this.data.preQualFileURL;
      } else if (value === "consentFile") {
        this.imageSrc = this.data.stuConsentFileURL;
      }
      this.showImage = true;
      this.componentKey += 1;
    },
    deleteImage(value) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "UserData.PIC_DELETE_CONFIRMATION", {
            width: "410px"
          })
          .then(confirm => {
            if (confirm) {
              if (value === "card") {
                this.cardDeleted = true;
              } else if (value === "birthCert") {
                this.birthCertDeleted = true;
              } else if (value === "guardianCard") {
                this.guardianCardDeleted = true;
              } else if (value === "militaryForm") {
                this.militaryFormDeleted = true;
              } else if (value === "personalImg") {
                this.data.personalImageURL = "";
                this.personalImgDelete = true;
              } else if (value === "certificateFile") {
                this.data.preQualFileURL = "";
                this.certifcateFileDelete = true;
              } else if (value === "stuResidence") {
                this.data.stuResidenceImageURL = "";
                this.stuResidenceDelete = true;
              } else if (value === "guardianResidence") {
                this.data.guardianResidenceImageURL = "";
                this.guardianResidenceDelete = true;
              } else if (value === "paymentReceipt") {
                this.data.paymentReceiptImageURL = "";
                this.paymentReceiptDelete = true;
              } else if (value === "consentFile") {
                this.data.stuConsentFileURL = "";
                this.consentFileDelete = true;
              }
            }
          });
    },
    submit(value, gotoStep4 = false) {
      if (this.isSubmitting) {
          return;
        }
      this.isSubmitting = true;
      return new Promise(resolve => {
        let validatePaymentReceipt = true;
        let validatePaymentReceiptNum = true;
        if (this.$refs.paymentReceiptImage && value !== '0' && this.data.feesRules.value2 === 'receipt' && this.data.referenceNum) {
          this.$refs.paymentReceiptImage.focus();
          this.$refs.referenceNum.focus();
          validatePaymentReceipt = this.$refs.paymentReceiptImage.validate();
          validatePaymentReceiptNum = this.$refs.referenceNum.validate();
        } else if (value !== '0' && this.data.feesRules.value2 === 'receipt' && !this.data.referenceNum) {
          validatePaymentReceiptNum = false
        }
        const validateForm = (this.data.appStatus === "7" ? true : this.$refs.stepForm3 ? this.$refs.stepForm3.validate() : false);
        if (validateForm && validatePaymentReceipt && validatePaymentReceiptNum) {
          const data = this.mapingData(value);

          // if (this.data.appStatus) data.requestFac = {desire: 1, faculty_id: this.facultySelections[0]}
          if (this.data.appStatus) {
                data.requestFac = {
                  desire: this.applicationID ? parseInt(this.data.currAppDesireNum) : this.data.loopIndex
                  ,faculty_id: this.facultySelections[0]
                };
              }


          data.mobile =
              this.data.appStatus === "7"
                  ? this.data.mobile
                  : this.bindProps.international;
          const formData = new FormData();
          formData.append("initialApplyPeriodCheck", this.data.initialApplyPeriodCheck || "0");
          formData.append("cardImage", this.cardImage || "");
          formData.append("birthCert", this.birthCert || "");
          formData.append("guardianCard", this.guardianCard || "");
          formData.append("militaryForm", this.militaryForm || "");
          formData.append("personlImage", this.personalImage || "");
          formData.append("preQualFile", this.certificatesFile || "");
          formData.append("consentFile", this.consentFile || "");
          formData.append("stuResidenceImage", this.stuResidenceImage || "");
          formData.append(
              "guardianResidenceImage",
              this.guardianResidenceImage || ""
          );
          formData.append(
              "paymentReceiptImage",
              this.paymentReceiptImage || ""
          );
          formData.append("Data", JSON.stringify(data));
          const header = {
            headers: {
              "Content-Type": `multipart/form-data; boundary=${formData._boundary}`
            }
          };
          const request = this.applicationID || this.data.appId

              ? this.$http.put(
                  "/api/applications/save_student_stepper_data/",
                  formData,
                  header
              )
              : this.$http.post(
                  "/api/applications/save_student_stepper_data/",
                  formData,
                  header
              );
          request.then(
              res => {
                this.isSubmitting = false;
                this.applicationID = res.data.data.applicationId;
                this.data.uid = res.data.data.uid;
                this.showToasted("success", res.data.message);
                resolve(this.applicationID);
                if (!gotoStep4) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      name: "ViewApplication",
                      params: {id: this.applicationID}
                    });
                  } else {
                    this.$router.push({name: "ListApplications"});
                  }
                }
              },
              err => {
                this.isSubmitting = false;
                this.showToasted("error", err.response.data.message);
                if (err.response.status === 404) {
                  this.$router.push({name: "ListApplications"});
                }
              }
          );
        } else {
          this.showToasted("error", this.$t("COMPLETE_DATA_ERROR"));
        }
      });
    },
    mapingData(value) {
      let editData = {};
      const data = {
        referenceNum: this.data.referenceNum || "",
        arName: this.data.arName || "",
        enName: this.data.enName || "",
        email: this.data.email || "",
        cardID: this.data.cardID || "",
        cardType: this.data.cardType || "",
        gender: this.data.gender || "",
        religion: this.data.religion || "",
        mobile: this.bindProps.international || "",
        telephone: this.data.telephone || "",
        dOB: this.data.dOB || "",
        otherCertificateText: this.data.otherCertificateText || "",
        total: this.data.total || "",
        percentage: this.data.percentage || "",
        requestAcadYear: this.data.currentYearId || "",
        requestAcadSemes: this.data.currentSemId || "",
        appStatus: value,
        currentAppStatus: this.data.currentAppStatus || '',
        nationalityCountry: this.data.nationalityCountry || "",
        addressCountry: this.data.addressCountry || "",
        addressState: this.data.addressState || "",
        addressCity: this.data.addressCity || "",
        birthPlaceCountry: this.data.birthPlaceCountry || "",
        birthPlaceState: this.data.birthPlaceState || "",
        birthPlaceCity: this.data.birthPlaceCity || "",
        certificateType: this.data.certificateType || "",
        divisionType: this.data.divisionType || "",
        equationCertificateType: this.data.equationCertificateType || "",
        foreignCertificate: this.data.foreignCertificate || "",
        preQualCountry: this.data.preQualCountry || 1,
        preQualYear: this.data.preQualYear || "",
        preQualYearHRId: this.data.preQualYearHRId || "",

        // requestFac: this.facultySelections
        //     .map((item, index) => !this.disabledSelections[index] ? {
        //       desire: this.data.loopIndex + index,
        //       faculty_id: item
        //     } : null)
        //     .filter(item => item !== null),

        requestFac: this.facultySelections
        .map((item, index) => !this.disabledSelections[index] ? {
          desire: this.applicationID
            ? parseInt(this.data.currAppDesireNum)
            : this.data.loopIndex + index,
          faculty_id: item
        } : null)
        .filter(item => item !== null),

        branchId: this.data.requestBranch || "",
        regionCode: this.bindProps.regionCode
      };
      const allowFileDelete =
          !this.certificatesFile && !this.data.total ? "delete" : "";
      if (this.applicationID || this.data.appId) {
        editData = {
          applicationID: this.applicationID,

          // currAppDesireNum: (data.requestFac.length > 0 ? data.requestFac[0].desire : this.data.currAppDesireNum),
          currAppDesireNum: this.applicationID  ? parseInt(this.data.currAppDesireNum)  : data.requestFac[0].desire,

          referenceNum: this.data.referenceNum,
          uid: this.data.uid,
          flagUpdatePersonalFile: this.personalImage ? 1 : 0,
          flagUpdatePreQualPDFFile: this.certificatesFile || allowFileDelete ? 1 : 0,
          flagUpdateStuConsentFile: this.consentFile ? 1 : 0,
          flagUpdateStuResidenceFile: this.stuResidenceImage || this.stuResidenceDelete ? 1 : 0,
          flagUpdateGuardianResidenceFile: this.guardianResidenceImage || this.guardianResidenceDelete ? 1 : 0,
          flagUpdateCardFile: this.cardImage ? 1 : 0,
          flagUpdatePaymentReceiptFile: this.paymentReceiptImage ? 1 : 0,
          flagUpdateBirthCert: this.birthCert ? 1 : 0,
          flagUpdateGuardianCard: this.guardianCard ? 1 : 0,
          flagUpdateMilitaryForm: this.militaryForm ? 1 : 0
        };
      }
      return Object.assign({}, data, editData);
    },
    openPaymentLink() {
      if (!this.paymentLink) {
        return this.showToasted("error", this.$t("NOT_FOUND_SERVER_ERROR"));
      }
      const popup = window.open(
          this.paymentLink,
          "PaymentWindow",
          "toolbar=no,menubar=no,fullscreen=yes,resizable=no,status=yes"
      );
      popup.resizeTo(screen.width, screen.height);
      let loader = null;
      loader = this.$loading.show({
        color: "#00AFB9",
        loader: "spinner",
        width: screen.width,
        height: 64,
        backgroundColor: "#000000",
        opacity: 0.5,
        zIndex: 99
      });
      const that = this;
      const loop = setInterval(function () {
        if (popup.closed) {
          clearInterval(loop);
          loader.opacity = 0;
          loader.zIndex = -1;
          loader.hide();
          that.getPaymentData(true);
        }
      }, 500);
    },
    getPaymentData(reLoadPaymentData = false) {
      if (this.applicationID || this.data.appId) {

        this.stepper.currentStep += reLoadPaymentData ? 0 : 1;
        const data = {applicationId: this.applicationID};
        var applicationStatus = this.data.appStatus;
        this.$http.post("/api/payment/check_payment/", data).then(
            res => {
              this.applicationID = res.data.data.applicationId;
              this.paymentData = res.data.data;
              this.paymentData.feesData = res.data.data.feesData[0];
              this.paymentData.feesData.paymentDate = this.paymentData.feesData.paymentDate.split(
                  "T"
              )[0];

              if (
                  this.paymentData.paymentStatus == 1 &&
                  (applicationStatus == 2 || reLoadPaymentData)
              )
                this.$router.push({name: "ListApplications"});

              this.paymentLink =
                  res.data.data.treasuryUrl +
                  "Service=Admission&ID=" +
                  this.paymentData.studentId +
                  "&Item=" +
                  this.paymentData.applicationId +
                  "&UnivId=" +
                  this.paymentData.univHrId +
                  "&NID=" +
                  this.data.cardID +
                  "&Lang=" +
                  this.locale;
            },
            err => {
              this.showToasted("error", err.response.data.message);
              this.$router.push({
                name: "ViewApplication",
                params: {id: this.applicationID}
              });
            }
        );
      }
    },

  }
};
</script>
